import { useState } from 'react';
import ApiResponseV2 from '../types/ApiResponseV2';
import CompatibilityViolation from '../types/CompatibilityViolation';

const baseUrl = 'https://tfdl5qaz6b.execute-api.eu-central-1.amazonaws.com';
// const baseUrl = 'http://localhost:8080'

interface UseCompatibilityApiProps {
  setCompatibilityViolation: (_: null | CompatibilityViolation) => void;
}

function useCompatibilityApi({
  setCompatibilityViolation,
}: UseCompatibilityApiProps) {
  const [result, setResult] = useState(null as null | ApiResponseV2);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function handleError(o: any) {
    setError(`Error fetching data: ${JSON.stringify(o)}`);
    setLoading(false);
  }

  function getCompatibility(leftText: string, rightText: string) {
    // setResult([
    //   {
    //     type: 'BACKWARD',
    //     incompatibilities: [{
    //       description: 'Field "f2" was added without a default value',
    //       fieldLocation: 'fields/f2',
    //       fieldName: 'f2'
    //     },
    //     {
    //       description: 'Field "f3" was added without a default value',
    //       fieldLocation: 'fields/f3',
    //       fieldName: 'f3'
    //     }]
    //   },
    //   {
    //     type: 'FORWARD'
    //   }
    // ])
    try {
      setCompatibilityViolation(null);
      setResult(null);
      setError('');
      setLoading(true);
      fetch(`${baseUrl}/api/v2/compatibility`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          left: leftText,
          right: rightText,
        }),
      })
        .then((response) => {
          if (response.ok && response.body != null) {
            return response.json();
          }
          response.json().then((json) => {
            handleError(json.errorMessage);
          });
        })
        .then((result) => setResult(result.body))
        .catch((error) => handleError(error))
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      handleError(error);
    }
  }

  return { result, error, loading, getCompatibility };
}

export default useCompatibilityApi;
